import React from 'react';

const SettingsSlider = ({
  label,
  value,
  onChange,
  min = 50,
  max = 150,
  step = 1,
  showPercentage = true,
  suffix = '%',
  multiplier = 100,
}) => {
  const displayValue = Math.round(value * multiplier);

  return (
    <div>
      <label className="block text-xs text-muted mb-1">
        {label}: {displayValue}{suffix}
      </label>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value * multiplier}
        onChange={(e) => onChange(parseInt(e.target.value) / multiplier)}
        className="w-full h-2 bg-dark-border/50 rounded-lg appearance-none cursor-pointer accent-carmin"
      />
    </div>
  );
};

export default SettingsSlider;
